import { useLayoutEffect } from "react";
import { useNavigate } from "react-router";
import { selectIsAuthenticated, useAppSelector } from "../store";
import {
  getPostLoginHomePath,
  getSsoLoginUrl,
  redirectToSsoLogin,
} from "./ssoConfig";

/**
 * Public root entry for Single Sign-On.
 * Sends unauthenticated users straight to the environment start-SSO URL
 * without showing an intermediate “in progress” page.
 */
export function SsoRedirect() {
  const navigate = useNavigate();
  const isAuthed = useAppSelector(selectIsAuthenticated);
  const ssoLoginUrl = getSsoLoginUrl();

  useLayoutEffect(() => {
    if (isAuthed) {
      navigate(getPostLoginHomePath(), { replace: true });
      return;
    }
    redirectToSsoLogin();
  }, [isAuthed, navigate]);

  if (isAuthed || ssoLoginUrl) {
    return null;
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-4 dark:bg-gray-950">
      <div
        className="flex flex-col items-center gap-5"
        role="status"
        aria-live="polite"
        aria-busy="true"
      >
        <span
          className="relative inline-block h-10 w-10 animate-spin text-blue-700 dark:text-blue-400 [animation-duration:1.15s]"
          aria-hidden="true"
        >
          <span className="absolute left-1/2 top-0 block h-2.5 w-2.5 -translate-x-1/2 rounded-full bg-current" />
          <span className="absolute bottom-0 left-0 block h-2.5 w-2.5 rounded-full bg-current" />
          <span className="absolute bottom-0 right-0 block h-2.5 w-2.5 rounded-full bg-current" />
        </span>
        <p className="text-center text-base font-medium text-gray-800 dark:text-gray-100 sm:text-lg">
          Single Sign-On in progress
        </p>
      </div>
    </div>
  );
}
